import type {
  AnalyticsIntegration,
  IntegrationAccountGroup,
  IntegrationConsent,
  IntegrationIdentity,
  IntegrationProperties,
} from "@/shared/integrations/integration.types";
import { isPostHogConfigured, postHogIntegration } from "@/shared/integrations/posthog.integration";

const analyticsIntegrations: ReadonlyArray<AnalyticsIntegration> = [postHogIntegration];

export const isAnalyticsConfigured = isPostHogConfigured;

let analyticsConsent: IntegrationConsent = "unknown";

export function setAnalyticsConsent(consent: IntegrationConsent): void {
  analyticsConsent = consent;
  for (const integration of analyticsIntegrations) integration.setConsent(consent);
}

export function canCaptureAnalytics(): boolean {
  return isAnalyticsConfigured && analyticsConsent === "granted";
}

export function captureAnalytics(name: string, properties?: IntegrationProperties): void {
  if (!canCaptureAnalytics()) return;
  for (const integration of analyticsIntegrations) integration.capture(name, properties);
}

export function identifyIntegrations(identity: IntegrationIdentity): void {
  if (!canCaptureAnalytics()) return;
  for (const integration of analyticsIntegrations) integration.identify(identity);
}

export function groupIntegrationAccount(group: IntegrationAccountGroup): void {
  if (!canCaptureAnalytics()) return;
  for (const integration of analyticsIntegrations) integration.groupAccount(group);
}

export async function resetIntegrations(): Promise<void> {
  await Promise.all(analyticsIntegrations.map((integration) => integration.reset()));
}
